export const UPDATE_COMMON_STATE = 'UPDATE_COMMON_STATE';